<template>
  <div class="row" style="padding:25px;">
    <div class="col-md-6 col-xs-12">
      <v-calendar
        locale="zh-HK"
        :attributes="attrs"
        @dayclick="dayClicked"
        is-expanded
        :theme-styles="themeStyles"
        @update:from-page="monthChanged"
      ></v-calendar>
    </div>
    <div class="col-md-6 col-xs-12">
      <div class="calendar-table">
        <div class="inner clearfix">
          <table align="left">
            <tbody>
              <tr v-for="item in filteredItems">
                <th align="right" style="font-size:16px;">
                  {{item.start}}
                  <span class></span>
                </th>
                <td class="md"></td>
                <td style="padding-left:20px;font-size:16px;">
                  <a href="/calendar">{{item.title}}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <span v-if="filteredItems.length==0">暫時沒有相關資料</span>
    </div>
  </div>
</template>

{ color: '#333333', fontSize: '.6rem', whiteSpace: 'nowrap' }

<script>
export default {
  data() {
    const hSpacing = "15px";
    return {
      attrs: [],
      items: [],
      filteredItems: [],
      themeStyles: {
        wrapper: {
          // background: 'linear-gradient(to bottom right, green, #ff66b3)',
          color: "black",
          border: "1px solid",
          // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: "5px"
        },
        header: {
          padding: `20px ${hSpacing}`
        },
        headerTitle: {
          fontWeight: "blod",
          fontSize: "20px"
        },
        headerArrows: {
          fontWeight: "blod",
          fontSize: "20px"
        },
        dayPopoverHeader: {
          fontSize: "26px"
        },
        dayPopoverContent: {
          color: "#333333",
          whiteSpace: "nowrap",
          fontSize: "2rem"
        },
        headerHorizontalDivider: {
          borderTop: "solid rgba(255, 255, 255, 0.2) 1px",
          width: "80%"
        },
        weekdays: {
          // color: '', // New color
          fontWeight: "600", // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
          fontSize: "20px"
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
          fontSize: "20px"
        },
        dayContent: {
          fontSize: "20px"
        }
      }
    };
  },
  mounted() {
    //       var date = d.getDate();
    // var month = d.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
    // var year = d.getFullYear();
    this.init();
  },
  methods: {
    init() {
      //   var date = new Date();
      //   this.fetchData(date.getFullYear(), date.getMonth() + 1);
    },
    fetchData(year, month) {
      let url = `/calendar/getByMonth/${year}/${month}`;
      //   console.log("url = %o", url);
      axios.get(url).then(res => {
        if (res.data) {
          //   console.log("calendar response data", res.data);
          this.items = res.data;
          this.filteredItems = res.data;
          this.attrs = res.data.map(b => {
            // console.log("map b", b);
            return {
              key: b.id,
              dates: [
                {
                  start: new Date(b.start),
                  end: new Date(b.end)
                }
              ],
              highlight: {
                backgroundColor: b.backgroundColor,
                height: "33px"
              },
              contentStyle: {
                color: b.color
              },
              popover: {
                label: b.title,
                labelStyle: {
                  fontSize: "20px"
                }
              },
              customData: b
            };
          });
        }
      });
    },
    monthChanged(e) {
      //   console.log("month changed", e.month, e.year);
      this.fetchData(e.year, e.month);
    },
    dayClicked(e) {
      //   console.log("day dayClicked", e);
      this.filteredItems = _.filter(this.items, function(o) {
        let sDay = new Date(o.start).getDate();
        let eDay = new Date(o.end).getDate();
        return sDay <= e.day && eDay >= e.day;
      });
    }
  }
};
</script>

<style scoped>
.c-header .c-title-layout .c-title-popover {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: inherit;
  -ms-flex-pack: inherit;
  justify-content: inherit;
  font-size: 30px;
}

.popover-container {
  font-size: 30px;
  position: relative;
  display: inline-block;
  outline: none;
}

.c-title-popover .popover-container {
  font-size: 30px !important;
}

.popover-content .direction-bottom .align-center {
  font-size: 30px;
}

.c-table-cell {
  font-size: 30px;
}

table th,
table td {
  padding: 0;
  vertical-align: middle;
}

table {
  font-size: 16px;
}

.calendar-table {
  margin-top: 20px;
  margin-bottom: 10px;
  border-spacing: 0 10px;
  border-collapse: separate;
}

.calendar-table table th {
  width: 160px;
  border-width: 0;
  background-color: transparent;
  padding-right: 0;
  padding-left: 30px;
}

.calendar-table table td.md {
  width: 1px;
  border-width: 0 1px 0 0;
  padding-left: 0;
  color: #2e6f36;
  border: 1px solid #b4d4c1;
}

.calendar-table table td {
  padding-top: 15px;
  padding-bottom: 15px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/mlang/calendar/home-calendar.vue